import React from 'react'

// components
import RegionInputUS from './RegionInputUS'
import RegionInputInternational from './RegionInputInternational'

const CountryAwareRegionInput = props => {
  const { onChangeFormField, states, form, formErrors } = props

  if (form.country == 'US') {
    return (
      <RegionInputUS
        onChangeFormField={onChangeFormField}
        states={states}
        form={form}
        formErrors={formErrors}
      />
    )
  } else {
    return (
      <RegionInputInternational
        onChangeFormField={onChangeFormField}
        form={form}
        formErrors={formErrors}
      />
    )
  }
}

export default CountryAwareRegionInput
